import { LocalStorageKeys } from '../app/constants'
import { globalState } from '@codeleap/store'

const lessonStore = globalState({ openedLessons: [] }, { persistKey: LocalStorageKeys.LESSON_STORE })

export const resetLessonStore = () => {
  return lessonStore.reset({ openedLessons: [] })
}

export const getOpenedLessons = () => {
  return lessonStore.get().openedLessons
}

export const setOpenedLessons = openedLessons => {
  return lessonStore.set({ openedLessons })
}
